// extracted by mini-css-extract-plugin
export default {"ErrorMessageContainer":"ErrorMessage_ErrorMessageContainer__PW8zG","Message":"ErrorMessage_Message__36RxR"};